export class BettableButton extends Phaser.GameObjects.Container {

	private textures: { normal: string, highlighted: string, winning: string }
	public bettableButtonBackground: Phaser.GameObjects.Image;

	constructor(private nameOfButton: string, private spriteSheet: string, scene: Phaser.Scene, x: number, y: number, w: number, h: number, texNormal: string, texHigh: string, texWin: string) {
		super(scene, x, y);
		this.x = x;
		this.y = y;
		this.width = w;
		this.height = h;
		this.textures = {
			normal: texNormal,
			highlighted: texHigh,
			winning: texWin
		};

		this.bettableButtonBackground = new Phaser.GameObjects.Image(scene, 0, 0, spriteSheet, texNormal);
		this.bettableButtonBackground.setDisplaySize(w, h);
		this.add(this.bettableButtonBackground);
	}

	get Name(): string {
		return this.nameOfButton
	}

	SetHighlighted(): void {
		this.bettableButtonBackground.setTexture(this.spriteSheet, this.textures.highlighted)
	}

	SetNormal(): void {
		this.bettableButtonBackground.setTexture(this.spriteSheet, this.textures.normal)
	}

	SetWinning(): void {
		this.bettableButtonBackground.setTexture(this.spriteSheet, this.textures.winning)
	}
}